import React from 'react';

('use client');

import { HiOutlineArrowRight } from 'react-icons/hi';
import { Button } from 'flowbite-react';

const Btn = ({ text, onClick, disabled }) => {
  return (
    <div>
      <Button
        className="ml-5 font-bold"
        size="sm"
        color="dark"
        disabled={disabled}
        onClick={onClick}>
        {text}
        <HiOutlineArrowRight className="ml-2 h-5 w-5" />
      </Button>
    </div>
  );
};

export default Btn;
